export default __webpack_public_path__ + "static/media/button talkback-4.9c06640e.png";